/* Cart click guard.
   (This file used to be a duplicate of mrwish-cart-v10.js. That duplicate bound a
   second add-to-cart handler and is gone.)

   Problem: the theme addresses cart lines by position (line: 3). Removing a line
   shifts every later line up by one. Clicking a second remove button before the
   first request has come back sends a position that now means a different item,
   so Shopify removes the wrong row, answers "line parameter is invalid", or the
   late response repaints the old state and it looks like nothing was deleted.

   Fix: allow only one cart write at a time. Clicks made while a request is still
   in flight are swallowed, so every request is built from an up to date DOM.
   A dropped click is harmless - the customer clicks again - and it is far better
   than deleting an item they did not pick.

   Proper fix, for whoever touches the cart sections next: address lines by their
   line item key instead of their position, and disable the row controls while a
   request is pending. */
(function(){
  if(window.__MRWISH_CART_GUARD__) return;
  window.__MRWISH_CART_GUARD__=true;

  var inflight=0;
  var origFetch=window.fetch;

  window.fetch=function(input){
    var url=(typeof input==='string') ? input : (input && input.url) || '';
    var isCartWrite=/\/cart\/(change|update|add|clear)/.test(url);
    var p=origFetch.apply(window, arguments);
    if(!isCartWrite) return p;

    inflight++;
    document.documentElement.setAttribute('data-cart-busy','');
    var done=function(){
      inflight=Math.max(0, inflight-1);
      if(inflight===0) document.documentElement.removeAttribute('data-cart-busy');
    };
    return p.then(function(r){ done(); return r; }, function(err){ done(); throw err; });
  };

  document.addEventListener('click', function(e){
    if(inflight===0) return;
    var control=e.target.closest('cart-remove-button, .cart-remove-button, .quantity__button, cart-remove-button button');
    if(!control) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
